<template>
  <el-drawer v-model="visible" title="部门详情" destroy-on-close>
    <el-form label-width="100px">
      <template v-for="column in columns" :key="column.prop">
        <el-form-item v-if="!column.notShow" :label="column.label">
          <el-input v-model="unit[column.prop]" readonly :type="column.type" :rows="column.rows"></el-input>
        </el-form-item>
      </template>      
    </el-form>
  </el-drawer>
</template>

<script>
import { defineComponent } from 'vue';
import { getUnitById } from '@/api/sys/org';

export default defineComponent({
  emits: ['update:modelValue'],
  props: {
    orgUnit: Object,
    modelValue: Boolean
  },
  data() {
    return {
      unit: {}
    }
  },
  computed: {
    visible: {
      get() {
          return this.modelValue; 
      },
      set(value) {
          this.$emit('update:modelValue', value); 
      }
    },
    columns() {
      return [
        { prop: 'name', label: '部门名称：' },
        { prop: 'briefName', label: '部门简称' },
        { prop: 'parentName', label: '上级部门', notShow: !this.unit.pid },
        { prop: 'contactName', label: '负责人' },
        { prop: 'contactPhone', label: '联系电话' },
        { prop: 'briefIntro', label: '简介', type: 'textarea', rows: 5 }
      ]
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getUnit();
      }
    }
  },
  methods: {
    getUnit() {
      getUnitById(this.orgUnit.unitId).then(({data}) => {
        this.unit = data.data;
        this.unit.parentName = this.orgUnit.parentName;
      })
    }
  }
})
</script>
